module.exports = __webpack_public_path__ + "static/media/upsell-caret-right.a4f3ad2e.svg";